import React from 'react';
import { scrollToCompra } from '../utils/scroll';
import { Shield } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-charcoal text-white py-16 px-4 text-center" data-id="element-49">
      <div className="max-w-3xl mx-auto" data-id="element-50">
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-51">
          MEGA PACK KINESIOLOGÍA™
        </h2>
        <p className="text-xl text-gray-300 mb-10" data-id="element-52">
          Porque tu práctica profesional merece un sistema.{' '}
          <br className="hidden md:block" data-id="element-53" />
          <span className="text-white font-semibold" data-id="element-54">
            No protocolos sueltos buscados en Google a las 11 de la noche.
          </span>
        </p>

        <button onClick={scrollToCompra} className="w-full max-w-md mx-auto bg-brand-teal hover:bg-brand-teal/90 text-white font-bold py-4 px-8 rounded-xl shadow-lg transition-all transform hover:-translate-y-1 text-lg mb-8" data-id="element-55">
          QUIERO EL MEGA PACK AHORA →
        </button>

        <div className="text-gray-400 text-sm space-y-2" data-id="element-56">
          <p data-id="element-57">$19.990 ARS · Descarga inmediata · Garantía de 7 días</p>
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-58">
            <Shield size={14} data-id="element-59" />
            <span data-id="element-60">Pago seguro con Mercado Pago</span>
          </div>
          <p className="text-xs mt-2" data-id="element-61">
            Visa · Mastercard · American Express · Débito · Transferencia ·
            Efectivo
          </p>
        </div>
      </div>
    </footer>;
}